<template>
  <div class="main-body">
    <div class="header">活动时长</div>
    <div class="out">

      <div class="search2">

        <download-excel
            class = "export-excel-wrapper"
            :fetch           = "fetchData"
            :fields          = "json_fields"
            :before-generate = "startDownload"
            :before-finish   = "finishDownload"
            name = "活动时长.xls"
            style="display: inline-block;margin-right: 0px;">
          <el-button type="primary" size="mini" icon="el-icon-download" plain>导出</el-button>
        </download-excel>

        <div style="float:right">

          <el-date-picker style="margin-right: 5px;width:220px;" title="起止时间" size="mini"
                          v-model="startEndTime" :clearable="false"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间">
          </el-date-picker>

          <el-button size="mini" type="primary" icon="el-icon-search" plain @click="getList(true)">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData"
                :height="th" border>


        <el-table-column prop="activityOrderDTO.activityContentName" label="活动项目" width="140"></el-table-column>
        <el-table-column prop="activityOrderDTO.activityClassName" label="活动分类" width="140"></el-table-column>
        <el-table-column prop="activityOrderDTO.practiceSiteName" label="站点" width="140"></el-table-column>
        <el-table-column prop="activityOrderDTO.activityAddress" label="地址" width="140"></el-table-column>
        <el-table-column prop="userName" label="工作人员" width="100"></el-table-column>

        <el-table-column prop="startTime" :formatter="timefilter" label="开始时间" min-width="160"></el-table-column>
        <el-table-column prop="endTime" :formatter="timefilter" label="结束时间" min-width="160"></el-table-column>

        <el-table-column prop="endTime" :formatter="timeLong" width="200" label="服务时长"></el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode, getToken} from "@/utils/auth";
import Edit from "./Edit";

export default {
  name: "Page",
  data(){
    return{

      tableLoading:false,

      showModal:false,
      showModalEdit:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      startEndTime:[],

      json_fields: {
        "活动项目": "activityOrderDTO.activityContentName",
        "活动分类": "activityOrderDTO.activityClassName",
        "站点": "activityOrderDTO.practiceSiteName",
        "地址": "activityOrderDTO.activityAddress",
        "工作人员": "userName",
        "开始时间": {
          field:"startTime",
          callback:value=>{
            return timefilters(value);
          }
        },
        "结束时间": {
          field:"endTime",
          callback:value=>{
            return timefilters(value);
          }
        },
        "服务时长": {
          callback:value=>{

            let rv = "";
            if(value.endTime !=null){

              let pt = value.startTime;
              let et = value.endTime;


              //var d1 = new Date('2016/03/28 10:17:22');
              var d1 = new Date(timefilters(pt));
              var d2 = new Date(timefilters(et));

              //console.log(parseInt(d2 - d1));//两个时间相差的毫秒数
              //console.log(parseInt(d2 - d1) / 1000);//两个时间相差的秒数
              //console.log(parseInt(d2 - d1) / 1000 / 60);//两个时间相差的分钟数
              //console.log(parseInt(d2 - d1) / 1000 / 60 / 60);//两个时间相差的小时数

              let fen = parseInt(d2 - d1) / 1000 / 60;

              let f1 = parseInt(fen,10);

              let h1 = Math.floor(f1/60);
              let y1 = f1%60;

              rv = h1+"小时"+y1+"分";

            }
            return rv;


          }
        },

      },

    }
  },
  components:{
    Edit
  },
  created(){

    const end = new Date();
    const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
    this.startEndTime = [start, end];

    this.th = this.$store.state.tableHeight;

    this.getList();

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{



    timefilter(row,index,column){
      return timefilters(column)
    },
    timeLong(row, column, cellValue) {
      if (cellValue) {
        let rv = "";
        if(row.endTime!=null){

          let pt = row.startTime;
          let et = row.endTime;


          //var d1 = new Date('2016/03/28 10:17:22');
          var d1 = new Date(timefilters(pt));
          var d2 = new Date(timefilters(et));

          //console.log(parseInt(d2 - d1));//两个时间相差的毫秒数
          //console.log(parseInt(d2 - d1) / 1000);//两个时间相差的秒数
          //console.log(parseInt(d2 - d1) / 1000 / 60);//两个时间相差的分钟数
          //console.log(parseInt(d2 - d1) / 1000 / 60 / 60);//两个时间相差的小时数

          let fen = parseInt(d2 - d1) / 1000 / 60;

          let f1 = parseInt(fen,10);

          let h1 = Math.floor(f1/60);
          let y1 = f1%60;

          rv = h1+"小时"+y1+"分";

        }
        return rv;
      }
    },



    handleEdit(row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch) {

      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ActivityUser/GovPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          startTime: timefilters(this.startEndTime[0]).substring(0,10),
          endTime: timefilters(this.startEndTime[1]).substring(0,10),
        }
      }).then( (response)=> {
        //console.log(response);
        this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        this.tableLoading=false
        console.log(error);
      });
    },


    async fetchData(){

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        pageIndex:1,
        pageSize:99999,
        startTime: timefilters(this.startEndTime[0]).substring(0,10),
        endTime: timefilters(this.startEndTime[1]).substring(0,10),

      }

      const response = await this.$axios.post(this.$shopUrl+"ActivityUser/GovPage",data);
      return response.data.data.pageInfo.list;
    },

    startDownload:function (){
      this.showModal = true;
    },

    finishDownload:function (){
      this.showModal = false;
    },


  }
}
</script>

<style scoped>

.main-body{
  background-color: #f2f2f2;height: 100%;
}

.main-body .header{
  background-color: #fff;padding:0px 10px; line-height: 50px;border-bottom: 1px solid #ddd;
}

.main-body .out {
  padding: 10px;
}

.main-body .out .search{

}

.main-body .out .table {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.main-body .out .page {
  background-color: #fff;padding: 10px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}



.mask {
  background-color: rgb(0, 0, 0);
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199
}
.mask .lodingsIcon{
  /* margin-top: 47vh; */
  margin: 47vh auto;
  height: 6vh;
  width: 300px;
  font-size: 18px;
  color: white;
}
.lodingsIcon i{
  z-index: 200;
  font-size: 25px;
  margin-right:10px ;

}
.label{
  padding: 5px 0px;
}

</style>
